/**
 * Variant Image Filter Configuration
 *
 * This file allows you to manually configure which images belong to which variants
 * Use this when variant.featured_media alone is not sufficient
 *
 * Example configuration:
 * {
 *   "product-handle": {
 *     "variants": {
 *       "40936299593775": [0, 1, 2, 3],  // Variant ID -> Image indices
 *       "40936299626543": [4, 5, 6, 7]
 *     },
 *     "options": {
 *       "Color": {
 *         "Red": [0, 1, 2, 3],      // Option value -> Image indices
 *         "Blue": [4, 5, 6, 7]
 *       }
 *     }
 *   }
 * }
 */

window.VARIANT_IMAGE_CONFIG = window.VARIANT_IMAGE_CONFIG || {};

// Example configuration for a product
// Uncomment and modify for your products:

/*
window.VARIANT_IMAGE_CONFIG = {
  // Product handle (from product URL)
  "example-product-tshirt": {
    // Method 1: Map by variant ID
    "variants": {
      "40936299593775": [0, 1, 2, 3],  // Red variant shows first 4 images
      "40936299626543": [4, 5, 6, 7],  // Blue variant shows next 4 images
      "40936299659311": [8, 9, 10, 11] // Green variant shows last 4 images
    }
  },

  // Method 2: Map by option value (more flexible)
  "another-product": {
    "options": {
      "Color": {
        "Red": [0, 1, 2],
        "Blue": [3, 4, 5],
        "Green": [6, 7, 8]
      }
    }
  },

  // Method 3: Complex mapping with multiple options
  "complex-product": {
    "options": {
      "Color": {
        "Red": [0, 1, 2, 3, 4],
        "Blue": [5, 6, 7, 8, 9]
      },
      "Size": {
        "Small": [0, 5],  // Show only certain angles for each size
        "Large": [1, 6]
      }
    },
    "mode": "intersection" // or "union" - how to combine multiple option filters
  }
};
*/

// Helper function to get config for current product
window.getVariantImageConfig = function(productHandle) {
  return window.VARIANT_IMAGE_CONFIG[productHandle] || null;
};

// Helper to configure a product programmatically
window.setVariantImageConfig = function(productHandle, config) {
  window.VARIANT_IMAGE_CONFIG[productHandle] = config;
  console.log('[VariantImageFilter] Config set for:', productHandle);

  // Reload filters if already initialized
  if (window.variantImageFilters) {
    window.variantImageFilters.forEach(filter => {
      if (filter.productHandle === productHandle) {
        filter.buildVariantImageMap();
        console.log('[VariantImageFilter] Config reloaded for:', productHandle);
      }
    });
  }
};

console.log('[VariantImageFilter] Config loaded');
